import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { RouterModule, Routes } from '@angular/router';
import { ProfileIncomeComponent } from './containers/profile-income/profile-income.component';
import { MaterialModule } from '../../../assets/material/material.module';
import { GrossIncomeEditModeComponent } from './containers/gross-income-edit-mode/gross-income-edit-mode.component';
import { SharedModule } from '../shared/shared.module';
import { ConfirmIncomeChangeModalComponent } from './components/confirm-income-change-modal/confirm-income-change-modal.component';
import { ReactiveFormsModule } from '@angular/forms';
import { UpdateIncomeModalComponent } from './components/update-income-modal/update-income-modal.component';
import { ProfileComponent } from './containers/profile/profile.component';
import { ProfileResidenceComponent } from './containers/profile-residence/profile-residence.component';
import { ProfileDetailsComponent } from './components/profile-details/profile-details.component';
import { ProfileHeaderComponent } from './components/profile-header/profile-header.component';
import { ProfileModalEntriesComponent } from './components/profile-modal-entries/profile-modal-entries.component';
import { ProfileConfirmationFooterComponent } from './components/profile-confirmation-footer/profile-confirmation-footer.component';
import { ConfirmResidenceChangeModalComponent } from './components/confirm-residence-change-modal/confirm-residence-change-modal.component';
import { ProfileResidenceEditComponent } from './containers/profile-residence-edit/profile-residence-edit.component';
import { IconCloseComponent } from '../shared/components/icon-close/icon-close.component';
import { NotificationComponent } from '../shared/components/notification/notification.component';
import { StoreModule } from '@ngrx/store';
import { profileReducers } from './store/reducers/profile.reducer';
import { EffectsModule } from '@ngrx/effects';
import { ProfileEffects } from './store/effects/profile.effects';

export const profileRoutes: Routes = [
  {
    path: '',
    component: ProfileComponent,
    children: [
      {
        path: '',
        redirectTo: 'income',
        pathMatch: 'full',
      },
      {
        path: 'income',
        component: ProfileIncomeComponent,
      },
      {
        path: 'vehicle',
        redirectTo: 'income',
        pathMatch: 'full',
      },
      {
        path: 'residence',
        component: ProfileResidenceComponent,
      },
    ],
  },
];

@NgModule({ declarations: [
        ProfileIncomeComponent,
        GrossIncomeEditModeComponent,
        ConfirmIncomeChangeModalComponent,
        UpdateIncomeModalComponent,
        ProfileComponent,
        ProfileResidenceComponent,
        ProfileDetailsComponent,
        ProfileHeaderComponent,
        ProfileModalEntriesComponent,
        ProfileConfirmationFooterComponent,
        ConfirmResidenceChangeModalComponent,
        ProfileResidenceEditComponent,
    ],
    exports: [ProfileIncomeComponent], imports: [StoreModule.forFeature('profile', profileReducers),
        EffectsModule.forFeature([ProfileEffects]),
        NotificationComponent,
        CommonModule,
        SharedModule,
        MaterialModule,
        RouterModule,
        ReactiveFormsModule,
        IconCloseComponent], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class ProfileModule {}
